<template>
  <div class="px-4">
    <template v-if="loading">
      <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
    </template>
    <template v-if="!loading && salarySumCurrency">
      <!-- <v-container> -->
      <div class="py-4">
        <v-row wrap>
          <v-col class="py-0" xs="5">Min:</v-col>
          <v-col class="py-0" xs="7">{{ salarySumCurrency.min | currency }}</v-col>
        </v-row>
        <v-row wrap>
          <v-col class="py-0" xs="5">Median:</v-col>
          <v-col class="py-0" xs="7">
            <b>{{ salarySumCurrency.median | currency }}</b>
          </v-col>
        </v-row>
        <v-row wrap>
          <v-col class="py-0" xs="5">Mean:</v-col>
          <v-col class="py-0" xs="7">
            <b>{{ salarySumCurrency.mean | currency }}</b>
          </v-col>
        </v-row>
        <v-row wrap>
          <v-col class="py-0" xs="5">Max:</v-col>
          <v-col class="py-0" xs="7">{{ salarySumCurrency.max | currency }}</v-col>
        </v-row>
        <v-row wrap>
          <v-col class="py-0" xs="5">Data Points:</v-col>
          <v-col class="py-0" xs="7">{{ salarySumCurrency.noOfPositions }}</v-col>
        </v-row>
        <v-row wrap>
          <v-col class="py-0" xs="7" offset="6">
            <a @click.stop="goToDetails(salarySummary)">Details...</a>
          </v-col>
        </v-row>
      </div>
      <!-- </v-container> -->
    </template>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import currency from '../util/currency';

export default {
  methods: {
    goToDetails() {
      this.$router.push({
        path: '/public/details',
        query: {
          sector: this.sectorSelected.name,
          jobGroup: this.onetJobGroupSelected.jobGroup,
          jobClass: this.jobClass,
          country: this.country.countryCode,
        },
      });
    },
    ...mapActions(['querySalarySummary']),
  },
  filters: {
    currency,
  },
  props: {
    country: Object,
    jobClass: Number,
    exchangeRate: Object,
  },
  data() {
    return {
      salarySummary: undefined,
      loading: false,
    };
  },
  computed: {
    salarySumCurrency() {
      if (!this.salarySummary) return undefined;
      return {
        max: this.salarySummary.max * this.exchangeRate.usdDivisor,
        min: this.salarySummary.min * this.exchangeRate.usdDivisor,
        median: this.salarySummary.median * this.exchangeRate.usdDivisor,
        mean: this.salarySummary.mean * this.exchangeRate.usdDivisor,
        noOfPositions: this.salarySummary.noOfPositions,
      };
    },
    ...mapState({
      onetJobGroupSelected: (state) => state.onetJobGroupSelected,
      sectorSelected: (state) => state.sectorSelected,
    }),
  },
  created() {
    this.$watch(
      () => `sector:${this.sectorSelected.name} - jobGroup:${this.onetJobGroupSelected.jobGroup} - country:${this.country.countryCode} - jobClass:${this.jobClass}`,
      () => {
        if (
          this.sectorSelected.name
          && this.onetJobGroupSelected.jobGroup
          && this.country.countryCode
          && this.jobClass != null
        ) {
          this.loading = true;
          this.querySalarySummary({
            sectorName: this.sectorSelected.name,
            onetJobGroup: this.onetJobGroupSelected.jobGroup,
            countryCode: this.country.countryCode,
            jobClass: this.jobClass,
          })
            .then((data) => {
              if (data) {
                this.salarySummary = data;
              }
            })
            .catch(() => {
              this.salarySummary = undefined;
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
      {
        immediate: true,
      },
    );
  },
};
</script>
